import React, { useState } from "react";

import "./topnav.css";

import { Link } from "react-router-dom";

import Dropdown from "../dropdown/Dropdown";

import ThemeMenu from "../thememenu/ThemeMenu";

import user_menu from "../../assets/JsonData/user_menus.json";

import useAuth from "../../hooks/useAuth";
import Popup from "../popup/Popup";
import LoginForm from "../form/loginForm/LoginForm";
import {
  clearLocal,
  getLocalAccessToken,
  getLocalRefreshToken,
  getLocalUser,
} from "../../utils/helper";
import { logout } from "../../apis/auth.api";

const renderUserToggle = (user) => (
  <div className="topnav__right-user">
    <div className="topnav__right-user__image">
      <img src={user.image} alt="" />
    </div>
    <div className="topnav__right-user__name">{user.display_name}</div>
  </div>
);

const renderUserMenu = (item, index) => (
  <Link to={item.pathname} key={index}>
    <div className="notification-item">
      <i className={item.icon}></i>
      <span>{item.content}</span>
    </div>
  </Link>
);

const Topnav = () => {
  const { auth, setAuth } = useAuth();

  const accessToken = getLocalAccessToken();
  const rToken = getLocalRefreshToken();

  const isShowLoginPopup = () => {
    if (!auth?.id) {
      clearLocal();
      return true;
    }
    if (!rToken || !accessToken) {
      clearLocal();
      return true;
    }

    return false;
  };

  const [currentUser, setCurrentUser] = useState(() => {
    const currentUser = getLocalUser();
    return {
      display_name: currentUser ? currentUser.fullName : "",
      image: currentUser ? currentUser.avatar : "",
    };
  });
  const [openPopup, setOpenPopup] = useState(isShowLoginPopup());

  const handleLogout = () => {
    // setOpenPopup(true);
    // setAuth({});
    // localStorage.removeItem("user");
    // localStorage.removeItem("token");

    logout(null, (result) => {
      setOpenPopup(true);
      setAuth({});
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    });
  };

  return (
    <div className="topnav">
      <div className="topnav__search">
        {/* <input type="text" placeholder="Search here..." />
        <i className="bx bx-search"></i> */}
      </div>
      <div className="topnav__right">
        {auth?.id ? (
          <div className="topnav__right-item">
            {/* dropdown here */}
            <Dropdown
              customToggle={() => renderUserToggle(currentUser)}
              contentData={user_menu}
              renderItems={(item, index) => renderUserMenu(item, index)}
            />
          </div>
        ) : (
          <div className="topnav__right-item">
            <i onClick={() => setOpenPopup(true)} className="bx bx-log-in"></i>
          </div>
        )}

        <div className="topnav__right-item">
          <ThemeMenu />
        </div>

        {auth.id && (
          <div className="topnav__right-item">
            <i onClick={() => handleLogout()} className="bx bx-log-out"></i>
          </div>
        )}
      </div>

      {openPopup && (
        <Popup
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "20%",
                maxWidth: "500px", // Set your width here
              },
            },
          }}
          title="Login"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <LoginForm
            setOpenPopup={() => setOpenPopup(false)}
            setCurrentUser={setCurrentUser}
          />
        </Popup>
      )}
    </div>
  );
};

export default Topnav;
